import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from './ui/Reveal';

/**
 * Inner-page banner: dark, left-aligned, hairline-ruled.
 * Carries top padding so the fixed header bar clears its content.
 */
export default function PageHeader({ eyebrow, title, native, lede, image, crumbs = [] }) {
  const lines = String(title).split('\n');

  return (
    <section className="relative overflow-hidden bg-royal-900">
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="" className="h-full w-full object-cover object-[center_26%] opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-r from-royal-900 via-royal-900/85 to-royal-900/55" />
        </div>
      )}
      {!image && <div className="absolute inset-0 paisley-bg opacity-[0.12]" />}

      <div className="shell relative pb-14 pt-14 sm:pb-16 sm:pt-16 lg:pb-24 lg:pt-24">
        {crumbs.length > 0 && (
          <nav
            aria-label="Breadcrumb"
            className="mb-9 flex items-center gap-2.5 text-[11.5px] uppercase tracking-wider2 text-cream/60"
          >
            {crumbs.map((c, i) => (
              <React.Fragment key={c.label}>
                {i > 0 && <span className="text-gold/40">—</span>}
                {c.to ? (
                  <Link to={c.to} className="transition-colors hover:text-gold-200">
                    {c.label}
                  </Link>
                ) : (
                  <span className="text-cream/85">{c.label}</span>
                )}
              </React.Fragment>
            ))}
          </nav>
        )}

        <Reveal className="max-w-3xl">
          {eyebrow && (
            <div className="flex items-center gap-4">
              <span className="rule-draw h-px w-10 bg-gold/50" />
              <span className="text-[12px] font-medium uppercase tracking-luxe text-cream/75">{eyebrow}</span>
            </div>
          )}

          <h1 className="mt-6 font-display text-[2.6rem] leading-[1.0] text-cream sm:text-[3.4rem] lg:text-[4.4rem]">
            {lines.map((line, i) => (
              <span key={line} className={`mask ${i === 1 ? 'mask-d1' : ''}`}>
                <span>{line}</span>
              </span>
            ))}
          </h1>

          {native && <p className="mt-3 font-display text-lg text-gold-300">{native}</p>}

          {lede && (
            <p className="mt-7 max-w-xl text-[15px] font-light leading-[1.8] text-cream/80">{lede}</p>
          )}
        </Reveal>
      </div>
    </section>
  );
}
